<script>
import {mapActions, mapState} from "pinia";
import {orgProfileStore} from "@/store/orgProfileStore";
import BaseLayout from "@/components/BaseLayout.vue";
import BaseSidebar from "@/components/BaseSidebar.vue";
import OrgProfileGeneralInfo from "@/views/profile/OrgProfileGeneralInfo.vue";
import OrgProfileContentInfo from "@/views/profile/OrgProfileContentInfo.vue";
import {authStore} from "@/store/authStore";
import {appStore} from "@/store/appStore";
import {StructuredDataType} from "@/store/model/StructuredData";


export default {
  name: "OrgProfileView",
  components: {
    BaseLayout,
    BaseSidebar,
    OrgProfileGeneralInfo,
    OrgProfileContentInfo
  },
  data() {
    return {
      isLoaded: false
    }
  },
  computed: {
    ...mapState(orgProfileStore,[
        'orgProfileInfo'
    ]),
    ...mapState(authStore,[
      'userProfiles'
    ]),
    orgId() {
      return Number(this.$route.params.id);
    },
    isOwnProfile() {
      const organizationProfile = this.userProfiles.find(userProfile => userProfile.type === 'ORGANIZATION');
      if (!organizationProfile || !organizationProfile.active) {
        return false;
      }
      return organizationProfile.organizations.some((org) => org.active && org.organization.id === this.orgId);
    }
  },
  methods: {
    ...mapActions(orgProfileStore, [
        'getOrgProfileInfo'
    ]),
    ...mapActions(appStore, [
      'setupStructuredData',
    ])
  },
  beforeMount() {
    this.setupStructuredData(StructuredDataType.ORGANIZATION, this.$route.params.id);
    this.getOrgProfileInfo(this.orgId).then(()=> this.isLoaded = true);
  }
}
</script>

<template>
<base-layout>
    <div v-if="isLoaded" class="org-profile-wrap">
      <org-profile-general-info :profile-info="orgProfileInfo"/>
      <div class="d-flex justify-content-between">
        <org-profile-content-info
            :org-id="orgId"
            :is-own-profile="isOwnProfile"
        />
        <base-sidebar/>
      </div>
    </div>
</base-layout>
</template>

<style lang="scss" scoped>

</style>